import { render, staticRenderFns } from "./FillInTheBlanks.vue?vue&type=template&id=12aaff5b&"
import script from "./FillInTheBlanks.vue?vue&type=script&lang=js&"
export * from "./FillInTheBlanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports